// import React, { useState } from 'react';
// import './AcademicPrograms.css';
// import { Link } from 'react-router-dom';

// export default function AcademicPrograms() {
//   const [activeTab, setActiveTab] = useState('undergraduate');

//   // Unified structured dataset containing items for all tabs
//   const programData = {
//     undergraduate: [
//       { id: 'ug1', title: 'Bachelor of Arts (BA)', duration: '3 Years', eligibility: '10+2 Pass', fee: '₹4,800/yr' },
//       { id: 'ug2', title: 'Bachelor of Commerce (BCom)', duration: '3 Years', eligibility: '10+2 Pass', fee: '₹5,200/yr' },
//       { id: 'ug3', title: 'Bachelor of Business Administration (BBA)', duration: '3 Years', eligibility: '10+2 Pass', fee: '₹6,000/yr' },
//       { id: 'ug4', title: 'Bachelor of Computer Applications (BCA)', duration: '3 Years', eligibility: '10+2 Pass', fee: '₹7,500/yr' },
//       { id: 'ug5', title: 'Bachelor of Science (BSc)', duration: '3 Years', eligibility: '10+2 Pass (Science)', fee: '₹5,500/yr' }
//     ],
//     postgraduate: [
//       { id: 'pg1', title: 'Master of Arts (MA)', duration: '2 Years', eligibility: 'Any Degree', fee: '₹6,000/yr' },
//       { id: 'pg2', title: 'Master of Commerce (MCom)', duration: '2 Years', eligibility: 'BCom/BBA', fee: '₹6,500/yr' },
//       { id: 'pg3', title: 'Master of Business Administration (MBA)', duration: '2 Years', eligibility: 'Any Degree', fee: '₹12,000/yr' },
//       { id: 'pg4', title: 'Master of Computer Applications (MCA)', duration: '2 Years', eligibility: 'BCA/BSc(CS)', fee: '₹14,000/yr' },
//       { id: 'pg5', title: 'Master of Social Work (MSW)', duration: '2 Years', eligibility: 'Any Degree', fee: '₹7,000/yr' }
//     ],
//     diploma: [
//       { id: 'dip1', title: 'PG Diploma in Computer Applications', duration: '1 Year', eligibility: 'Any Degree', fee: '₹5,000' },
//       { id: 'dip2', title: 'PG Diploma in Business Management', duration: '1 Year', eligibility: 'Any Degree', fee: '₹5,000' },
//       { id: 'dip3', title: 'Certificate in Spoken English', duration: '6 Months', eligibility: '10th Pass', fee: '₹2,500' },
//       { id: 'dip4', title: 'Certificate in Journalism', duration: '6 Months', eligibility: '10+2 Pass', fee: '₹3,000' }
//     ]
//   };

//   return (
//     <section className="programs-section" id="programs">
//       <div className="programs-container">
        
//         {/* Section Title Header */}
//         <div className="programs-header">
//           <span className="programs-sub">ACADEMIC PROGRAMS</span>
        
//           <p className="programs-desc">
//             Choose from a wide range of UG, PG, and Diploma programs designed for working professionals and distance learners.
//           </p>
//         </div>

//         {/* Dynamic Nav Tabs Control Center */}
//         <div className="tabs-control-wrapper">
//           <div className="tabs-bar">
//             <button 
//               className={`tab-btn ${activeTab === 'undergraduate' ? 'tab-active' : ''}`}
//               onClick={() => setActiveTab('undergraduate')}
//             >
//               Undergraduate
//             </button>
//             <button 
//               className={`tab-btn ${activeTab === 'postgraduate' ? 'tab-active' : ''}`}
//               onClick={() => setActiveTab('postgraduate')}
//             >
//               Postgraduate
//             </button>
//             <button 
//               className={`tab-btn ${activeTab === 'diploma' ? 'tab-active' : ''}`}
//               onClick={() => setActiveTab('diploma')}
//             >
//               Diploma &amp; Certificate
//             </button>
//           </div>
//         </div>

//         {/* Display Grid Area containing items mapped from active state */}
//         <div className={`programs-grid tab-theme-${activeTab}`}>
//           {programData[activeTab].map((prog) => (
//             <div key={prog.id} className="program-card">
//               {/* Top Accent Category Color Band Strip */}
//               <div className="card-accent-strip"></div>
              
//               <div className="card-body-content">
//                 <h3 className="program-title">{prog.title}</h3>
                
//                 <div className="program-meta-list">
//                   <div className="meta-row">
//                     <span className="meta-label">Duration:</span>
//                     <span className="meta-val">{prog.duration}</span>
//                   </div>
//                   <div className="meta-row">
//                     <span className="meta-label">Eligibility:</span>
//                     <span className="meta-val">{prog.eligibility}</span>
//                   </div>
//                   <div className="meta-row">
//                     <span className="meta-label">Fee:</span>
//                     <span className="meta-val highlight-fee">{prog.fee}</span>
//                   </div>
//                 </div>

//                 <button className="program-apply-btn">
//                   Apply Now <span className="btn-arrow">➔</span>
//                 </button>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Global Footer View Action Trigger */}
//         <div className="view-all-wrapper">
//                <Link to="/programs">
//           <button className="view-all-btn">
//             View All Programs <span className="arrow">➔</span>
//           </button>
//           </Link>
//         </div>

//       </div>
//     </section>
//   );
// }


import React, { useState, useEffect } from 'react';
import './AcademicPrograms.css';
import { Link } from 'react-router-dom';

export default function AcademicPrograms() {
  const [activeTab, setActiveTab] = useState('undergraduate');
  const [loading, setLoading] = useState(true);
  const [programData, setProgramData] = useState({
    undergraduate: [],
    postgraduate: [],
    diploma: []
  });

  // Fetch dynamic courses from API
  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await fetch('https://metapi.emedhatechnologies.com/api/courses/courses');
        const result = await response.json();

        if (result.success && Array.isArray(result.data)) {
          const categorized = {
            undergraduate: [],
            postgraduate: [],
            diploma: []
          };

          result.data.forEach((course) => {
            const durationText = `${course.minimum_duration || 1} ${Number(course.minimum_duration) > 1 ? 'Years' : 'Year'}`;
            const formattedFee = course.total_course_fee 
              ? `₹${Number(course.total_course_fee).toLocaleString('en-IN')}` 
              : 'N/A';

            const item = {
              id: course.id,
              title: `${course.course_name} (${course.course_code || ''})`,
              duration: durationText,
              eligibility: course.course_medium || 'Standard Eligibility',
              fee: formattedFee
            };

            const type = (course.program_type || '').toLowerCase();

            if (type.includes('under-graduate') || type.includes('ug')) {
              categorized.undergraduate.push(item);
            } else if (type.includes('post-graduate') || type.includes('pg')) {
              categorized.postgraduate.push(item);
            } else {
              categorized.diploma.push(item);
            }
          });

          setProgramData(categorized);
        }
      } catch (error) {
        console.error('Error fetching academic programs:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

  const activePrograms = programData[activeTab] || [];

  return (
    <section className="programs-section" id="programs">
      <div className="programs-container">
        
        {/* Section Title Header */}
        <div className="programs-header">
          <span className="programs-sub">ACADEMIC PROGRAMS</span>
          <h2 class="programs-main">Programs Offered – AY 2026–27</h2>
          <p className="programs-desc">
            Choose from a wide range of UG, PG, and Diploma programs designed for working professionals and distance learners.
          </p>
        </div>

        {/* Dynamic Nav Tabs Control Center */}
        <div className="tabs-control-wrapper">
          <div className="tabs-bar">
            <button 
              className={`tab-btn ${activeTab === 'undergraduate' ? 'tab-active' : ''}`}
              onClick={() => setActiveTab('undergraduate')}
            >
              Undergraduate ({programData.undergraduate.length})
            </button>
            <button 
              className={`tab-btn ${activeTab === 'postgraduate' ? 'tab-active' : ''}`}
              onClick={() => setActiveTab('postgraduate')}
            >
              Postgraduate ({programData.postgraduate.length})
            </button>
            <button 
              className={`tab-btn ${activeTab === 'diploma' ? 'tab-active' : ''}`}
              onClick={() => setActiveTab('diploma')}
            >
              Diploma &amp; Certificate ({programData.diploma.length})
            </button>
          </div>
        </div>

        {/* Display Grid Area containing items mapped from active state */}
        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px 0', fontFamily: 'Inter, sans-serif', color: '#556275' }}>
            <h3>Loading Academic Programs...</h3>
          </div>
        ) : activePrograms.length > 0 ? (
          <div className={`programs-grid tab-theme-${activeTab}`}>
            {activePrograms.map((prog) => (
              <div key={prog.id} className="program-card">
                {/* Top Accent Category Color Band Strip */}
                <div className="card-accent-strip"></div>
                
                <div className="card-body-content">
                  <h3 className="program-title">{prog.title}</h3>
                  
                  <div className="program-meta-list">
                    <div className="meta-row">
                      <span className="meta-label">Duration:</span>
                      <span className="meta-val">{prog.duration}</span>
                    </div>
                    <div className="meta-row">
                      <span className="meta-label">Medium:</span>
                      <span className="meta-val">{prog.eligibility}</span>
                    </div>
                    {/* <div className="meta-row">
                      <span className="meta-label">Total Fee:</span>
                      <span className="meta-val highlight-fee">{prog.fee}</span>
                    </div> */}
                  </div>

                  <Link to="/enquiry">
                    <button className="program-apply-btn">
                      Apply Now <span className="btn-arrow">➔</span>
                    </button>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div style={{ textAlign: 'center', padding: '36px 0', fontFamily: 'Inter, sans-serif', color: '#64748b' }}>
            <p>No programs available under this category at present.</p>
          </div>
        )}

        {/* Global Footer View Action Trigger */}
        <div className="view-all-wrapper">
          <Link to="/programs">
            <button className="view-all-btn">
              View All Programs <span className="arrow">➔</span>
            </button>
          </Link>
        </div>

      </div>
    </section>
  );
}